import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {categoryDefaults} from '@netx/core-category-next/defaults';
import {type ICategory} from '@netx/core-category-next/schema';
import {getCategoryData} from './getCategoryData';
import {
	pollUntil,
	getObjectIdFromProgressReport,
} from '@netx/core-next/utils/poll';

/**
 * `setCategoryObject` request params
 * (what is used to send to server)
 */
export interface SetCategoryObjectRequestOptions {
	category: Partial<ICategory>;
}

/**
 * `setCategoryObject` request
 * (what gets sent to the server)
 */
export type SetCategoryObjectRequest = [ICategory];

/**
 * `setCategoryObject` response
 * (what comes back from the server)
 */
export type SetCategoryObjectResponse =
	SuccessResponse<SetCategoryObjectResult>;

/**
 * `setCategoryObject` result
 * (what is utilized from the server response)
 */
export type SetCategoryObjectResult = string; // uuid

export const setCategoryObjectEndpoint = 'setCategoryObject';

/**
 * Create/update category
 * @param fetchParams Fetch params
 */
export const setCategoryObject = async ({
	category,
}: SetCategoryObjectRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: SetCategoryObjectRequest = [
		{...categoryDefaults, ...category},
	];

	return client
		.post<SetCategoryObjectResponse>(setCategoryObjectEndpoint, requestParams)
		.then((response) =>
			pollUntil({uuid: response.data.result, throwOnWarnings: true}).then(
				(progressReport) =>
					getCategoryData({
						id: getObjectIdFromProgressReport(progressReport, true),
					}),
			),
		);
};
export default setCategoryObject;
